import { Button } from "@repo/ui/components/ui/button";
import { RotateCcw } from "lucide-react";

/** Couleurs proposées : fiche sobre, nature, institutionnel. Le sélecteur natif permet toute autre couleur. */
const PRESETS = [
  "#808080",
  "#02BC77",
  "#4682B4",
  "#964B00",
  "#1F2937",
  "#B91C1C",
  "#F3F4F6",
  "#ECFDF5",
];

interface Props {
  label: string;
  /** Couleur enregistrée ; absente = couleur par défaut de la fiche. */
  value?: string;
  /** Couleur affichée quand aucune n'est enregistrée. */
  fallback: string;
  onChange: (value?: string) => void;
}

export function ColorField({ label, value, fallback, onChange }: Props) {
  return (
    <div className="flex items-center gap-1.5 text-xs">
      <span className="w-24 shrink-0 text-muted-foreground">{label}</span>
      <input
        type="color"
        value={value ?? fallback}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        aria-label={label}
        className="h-7 w-9 cursor-pointer rounded border border-input bg-background p-0.5"
      />
      <div className="flex gap-1">
        {PRESETS.map((color) => (
          <button
            key={color}
            type="button"
            onClick={() => onChange(color)}
            aria-label={`${label} : ${color}`}
            className={`h-4 w-4 shrink-0 rounded-full border ${value?.toLowerCase() === color.toLowerCase() ? "ring-2 ring-primary ring-offset-1" : "border-border"}`}
            style={{ backgroundColor: color }}
          />
        ))}
      </div>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-6 w-6"
        onClick={() => onChange(undefined)}
        disabled={!value}
        aria-label={`${label} : couleur par défaut`}
      >
        <RotateCcw className="h-3 w-3" />
      </Button>
    </div>
  );
}
